//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.AspectDetailsBuilder.js";
import "../no/ugmath.js";
import "../no/Diagramming.js";
let d=[[[0,"AspectBoxVariant",1,0],[1,"AspectDetails",0,"AME.AspectDetailsBuilder",0]],[[["cursorLocation"],"SetLocation",{},1,0],[["pageObject"],"CreateAspectBox",{R_:{sheetElement:"Diagramming.SheetElement"}},1,0]],[]];
SPLM.AME.AspectBoxBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.AspectBoxBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.AspectBoxBuilder.Variant = Object.freeze({
    "Vertical" : "Vertical", "Horizontal" : "Horizontal"});

export default SPLM;